const getSearchImageObj = (result) => {
  const returnCustomImage = (result?.category?.raw === 'TV Guide') && result?.customImage
  return (
    returnCustomImage ? JSON.parse(result?.customImage?.raw) : {
      _renditions: {
        '99x56': result?.image?.raw,
        '225x127': result?.image?.raw,
        // Uncommenting this line will make poster images filter through to search
        // Bug?: Even if not used, the aspect ratio seems to pick this up in the Image component
        // As part of the new search UI, we may not need the aspect ratios above
        // '300x400': result?.image?.raw,
      },
    }
  )
}

export default getSearchImageObj
